import gql from "graphql-tag";

export const flameRetardancyTestsQuery = gql`
  query FlameRetardancyTestsQuery($name: String) {
      flameRetardancyTests(name_Icontains: $name) {
          edges {
              node {
                  id
                  name
              }
          }
      }
  }
`;

export const gaugeRangeLimitsQuery = gql`
  query GaugeRangeLimitsQuery {
      gaugeRangeLimits
  }
`;

export const widthRangeLimitsQuery = gql`
  query WidthRangeLimitsQuery {
      generalWidthLimits
  }
`;

export const weightRangeLimitsQuery = gql`
  query WeightRangeLimitsQuery {
      generalWeightLimits
  }
`;

export const embossingsQuery = gql`
  query embossingsWithPattern {
      listEmbossingsWithPatternSelect {
        id
        name
      }
  }
`;
